/**
 * ! 신규 사이트 추가시 반드시 문서(https://gitlab.somansa.com/vdis/docs/-/wikis/%EC%82%AC%EC%9D%B4%ED%8A%B8-%EB%84%A4%EC%9E%84-%EC%A0%95%EC%9D%98)에 업데이트 해주세요.
 */

// 한국산업기술진흥원 커스텀 목록
export const siteName = 'kiat';
export { MultiFactor, Login } from './components';
